export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11860.a57fec30.jpg";